// 12 rhythm event type
export enum TYPE_RHYTHM_EVENT_ENUM {
  AFIB = 'AFIB',
  TACHY = 'TACHY',
  BRADY = 'BRADY',
  PAUSE = 'PAUSE',
  MAX_HR = 'MAX_HR',
  MIN_HR = 'MIN_HR',
  VT = 'VT',
  SVT = 'SVT',
  // AVB1 = 'AVB1',
  AVB2 = 'AVB2',
  AVB3 = 'AVB3',
  ARTIFACT = 'ARTIFACT',
}

export const TYPE_EVENT_OTHER = 'OTHERS';

// 12 beat event type
export enum TYPE_BEAT_EVENT_ENUM {
  SINGLE_VE = 'SINGLE_VE',
  VE_RUN = 'VE_RUN',
  VE_COUPLET = 'VE_COUPLET',
  VE_BIGEMINY = 'VE_BIGEMINY',
  VE_TRIGEMINAL = 'VE_TRIGEMINAL',
  VE_QUADRIGEMINY = 'VE_QUADRIGEMINY',
  SINGLE_SVE = 'SINGLE_SVE',
  SVE_RUN = 'SVE_RUN',
  SVE_COUPLET = 'SVE_COUPLET',
  SVE_BIGEMINY = 'SVE_BIGEMINY',
  SVE_TRIGEMINAL = 'SVE_TRIGEMINAL',
  SVE_QUADRIGEMINY = 'SVE_QUADRIGEMINY',
}

export enum TYPE_RR_HEART_MAP_ENUM {
  Q_TO_Q = 'qToQ',
  Q_TO_NSV = 'qToNSV',
  V = 'V',
  S = 'S',
  N = 'N',
}

export const BEAT_EVENT_LIST = Object.keys(TYPE_BEAT_EVENT_ENUM);
export const RHYTHM_EVENT_LIST_CAN_EDIT = Object.keys(TYPE_RHYTHM_EVENT_ENUM).filter(
  (x) => x !== TYPE_RHYTHM_EVENT_ENUM.MAX_HR && x !== TYPE_RHYTHM_EVENT_ENUM.MIN_HR,
);

export const PREVENT_AFIB_OVERRIDE_EVENT_LIST = [
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  // TYPE_RHYTHM_EVENT_ENUM.ARTIFACT,
  TYPE_BEAT_EVENT_ENUM.VE_COUPLET,
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.VE_BIGEMINY,
  TYPE_BEAT_EVENT_ENUM.VE_TRIGEMINAL,
  TYPE_BEAT_EVENT_ENUM.VE_QUADRIGEMINY,
];

export const LIST_EVENT_TYPE_QUERY = [
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.VE_COUPLET,
  TYPE_BEAT_EVENT_ENUM.VE_BIGEMINY,
  TYPE_BEAT_EVENT_ENUM.VE_TRIGEMINAL,
  TYPE_BEAT_EVENT_ENUM.VE_QUADRIGEMINY,
  TYPE_BEAT_EVENT_ENUM.SVE_RUN,
  TYPE_BEAT_EVENT_ENUM.SVE_COUPLET,
  TYPE_BEAT_EVENT_ENUM.SVE_BIGEMINY,
  TYPE_BEAT_EVENT_ENUM.SVE_TRIGEMINAL,
  TYPE_BEAT_EVENT_ENUM.SVE_QUADRIGEMINY,
  TYPE_RHYTHM_EVENT_ENUM.AFIB,
  TYPE_RHYTHM_EVENT_ENUM.TACHY,
  TYPE_RHYTHM_EVENT_ENUM.BRADY,
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  TYPE_RHYTHM_EVENT_ENUM.AVB2,
  TYPE_RHYTHM_EVENT_ENUM.AVB3,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.MAX_HR,
  TYPE_RHYTHM_EVENT_ENUM.MIN_HR,
  // TYPE_RHYTHM_EVENT_ENUM.ARTIFACT,
  TYPE_EVENT_OTHER,
];

export const LIST_EVENT_SKIP_ON_RUN_EVENT = [
  TYPE_RHYTHM_EVENT_ENUM.TACHY,
  TYPE_RHYTHM_EVENT_ENUM.BRADY,
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  TYPE_RHYTHM_EVENT_ENUM.AVB2,
  TYPE_RHYTHM_EVENT_ENUM.AVB3,
];

export const LIST_RUN_EVENT = [
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.SVE_RUN,
];

export const RR_INTERVAL_MENU = [
  //* Use id to call api
  {
    name: 'Q - Q beats',
    id: 'qToQ',
  },
  {
    name: 'Q - N/S/V beats',
    id: 'qToNSV',
  },
  {
    name: 'V beats',
    id: 'V',
  },
  {
    name: 'S beats',
    id: 'S',
  },
  {
    name: 'N beats',
    id: 'N',
  },
];

export enum TYPE_BEAT_ENUM {
  N = 'N',
  V = 'V',
  S = 'S',
  Q = 'Q',
  DELETED = 'Deleted',
}

export const OTHER_EVENT_LIST = [
  ...BEAT_EVENT_LIST,
  TYPE_RHYTHM_EVENT_ENUM.BRADY,
  TYPE_RHYTHM_EVENT_ENUM.TACHY,
  TYPE_RHYTHM_EVENT_ENUM.MAX_HR,
  TYPE_RHYTHM_EVENT_ENUM.MIN_HR,
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.AVB3,
  TYPE_RHYTHM_EVENT_ENUM.AVB2,
  // TYPE_RHYTHM_EVENT_ENUM.AVB1,
];

export const CANNOT_DELETE_EVENT = [TYPE_RHYTHM_EVENT_ENUM.MAX_HR, TYPE_RHYTHM_EVENT_ENUM.MIN_HR];

export const CANNOT_CHANGE_DURATION_EVENT = [
  ...BEAT_EVENT_LIST,
  TYPE_RHYTHM_EVENT_ENUM.MAX_HR,
  TYPE_RHYTHM_EVENT_ENUM.MIN_HR,
];

export const CANNOT_CHANGE_TYPE_EVENT = [
  ...BEAT_EVENT_LIST.filter(
    (x) => x !== TYPE_BEAT_EVENT_ENUM.VE_RUN && x !== TYPE_BEAT_EVENT_ENUM.SVE_RUN,
  ),
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  TYPE_RHYTHM_EVENT_ENUM.ARTIFACT,
  TYPE_RHYTHM_EVENT_ENUM.MAX_HR,
  TYPE_RHYTHM_EVENT_ENUM.MIN_HR,
];

export const canShowCountBeatEvents = [
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.SVE_RUN,
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
];

export const canAvgRhythmEvents = [
  TYPE_RHYTHM_EVENT_ENUM.AFIB,
  TYPE_RHYTHM_EVENT_ENUM.TACHY,
  TYPE_RHYTHM_EVENT_ENUM.BRADY,
];

export const canShowDurationEvents = [TYPE_RHYTHM_EVENT_ENUM.PAUSE];

export enum TYPE_SPECIAL_EVENT_ENUM {
  ALL_HR_RANGES = 'All HR ranges',
  SINUS_TACHY = 'Sinus Tachy',
  HIGH_TACHY = 'High Tachy',
  SINUS_BRADY = 'Sinus Brady',
  LOW_BRADY = 'Low Brady',
  SHORT_PAUSE = 'Short Pause',
  LONG_PAUSE = 'Long Pause',
}

export const RUN_EVENT_CHANGE_ALLOWED_TYPES = [
  TYPE_RHYTHM_EVENT_ENUM.AFIB,
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
  TYPE_RHYTHM_EVENT_ENUM.TACHY,
];

export const ADD_NEW_EVENT_TYPE_RHYTHM_EVENTS_TAB_OPTIONS = [
  { label: 'AFib', value: TYPE_RHYTHM_EVENT_ENUM.AFIB },
  { label: 'Tachy', value: TYPE_RHYTHM_EVENT_ENUM.TACHY },
  { label: 'Brady', value: TYPE_RHYTHM_EVENT_ENUM.BRADY },
  { label: 'Pause', value: TYPE_RHYTHM_EVENT_ENUM.PAUSE },
  { label: 'VT', value: TYPE_RHYTHM_EVENT_ENUM.VT },
  { label: 'SVT', value: TYPE_RHYTHM_EVENT_ENUM.SVT },
  // { label: '1st Deg HB', value: TYPE_RHYTHM_EVENT_ENUM.AVB1 },
  { label: '2nd Deg HB', value: TYPE_RHYTHM_EVENT_ENUM.AVB2 },
  { label: '3rd Deg HB', value: TYPE_RHYTHM_EVENT_ENUM.AVB3 },
];

export const ADD_NEW_EVENT_TYPE_BEAT_HR_TAB_OPTIONS = [
  { label: 'AFib', value: TYPE_RHYTHM_EVENT_ENUM.AFIB },
  { label: 'Artifact', value: TYPE_RHYTHM_EVENT_ENUM.ARTIFACT },
];

export const CHANGE_EVENT_TYPE_OPTIONS = [
  { label: 'AFib', value: TYPE_RHYTHM_EVENT_ENUM.AFIB },
  { label: 'VT', value: TYPE_RHYTHM_EVENT_ENUM.VT },
  { label: 'SVT', value: TYPE_RHYTHM_EVENT_ENUM.SVT },
  // { label: '1st Deg HB', value: TYPE_RHYTHM_EVENT_ENUM.AVB1 },
  { label: 'VE Run', value: TYPE_BEAT_EVENT_ENUM.VE_RUN },
  { label: 'SVE Run', value: TYPE_BEAT_EVENT_ENUM.SVE_RUN },
  { label: '2nd Deg HB', value: TYPE_RHYTHM_EVENT_ENUM.AVB2 },
  { label: '3rd Deg HB', value: TYPE_RHYTHM_EVENT_ENUM.AVB3 },
];

export const ECG_EVENT_MENU_OPTIONS = [
  {
    label: 'VE Couplet',
    value: TYPE_BEAT_EVENT_ENUM.VE_COUPLET,
    type: 'beat',
    subtype: 've',
  },
  {
    label: 'VE Run',
    value: TYPE_BEAT_EVENT_ENUM.VE_RUN,
    type: 'beat',
    subtype: 've',
  },
  {
    label: 'VE Bigeminy',
    value: TYPE_BEAT_EVENT_ENUM.VE_BIGEMINY,
    type: 'beat',
    subtype: 've',
  },
  {
    label: 'VE Trigeminy',
    value: TYPE_BEAT_EVENT_ENUM.VE_TRIGEMINAL,
    type: 'beat',
    subtype: 've',
  },
  {
    label: 'VE Quadrigeminy',
    value: TYPE_BEAT_EVENT_ENUM.VE_QUADRIGEMINY,
    type: 'beat',
    subtype: 've',
  },
  {
    label: 'SVE Couplet',
    value: TYPE_BEAT_EVENT_ENUM.SVE_COUPLET,
    type: 'beat',
    subtype: 'sve',
  },
  {
    label: 'SVE Run',
    value: TYPE_BEAT_EVENT_ENUM.SVE_RUN,
    type: 'beat',
    subtype: 'sve',
  },
  {
    label: 'SVE Bigeminy',
    value: TYPE_BEAT_EVENT_ENUM.SVE_BIGEMINY,
    type: 'beat',
    subtype: 'sve',
  },
  {
    label: 'SVE Trigeminy',
    value: TYPE_BEAT_EVENT_ENUM.SVE_TRIGEMINAL,
    type: 'beat',
    subtype: 'sve',
  },
  {
    label: 'SVE Quadrigeminy',
    value: TYPE_BEAT_EVENT_ENUM.SVE_QUADRIGEMINY,
    type: 'beat',
    subtype: 'sve',
  },
  {
    label: 'AFib',
    value: TYPE_RHYTHM_EVENT_ENUM.AFIB,
    type: 'rhythm',
    subtype: 'main',
  },
  {
    label: 'Tachy',
    value: TYPE_RHYTHM_EVENT_ENUM.TACHY,
    type: 'rhythm',
    subtype: 'other',
  },
  {
    label: 'Brady',
    value: TYPE_RHYTHM_EVENT_ENUM.BRADY,
    type: 'rhythm',
    subtype: 'other',
  },
  {
    label: 'Pause',
    value: TYPE_RHYTHM_EVENT_ENUM.PAUSE,
    type: 'rhythm',
    subtype: 'other',
  },
  {
    label: 'Max HR',
    value: TYPE_RHYTHM_EVENT_ENUM.MAX_HR,
    type: 'rhythm',
    subtype: 'other',
  },
  {
    label: 'Min HR',
    value: TYPE_RHYTHM_EVENT_ENUM.MIN_HR,
    type: 'rhythm',
    subtype: 'other',
  },
  {
    label: 'VT',
    value: TYPE_RHYTHM_EVENT_ENUM.VT,
    type: 'rhythm',
    subtype: 'other',
  },
  {
    label: 'SVT',
    value: TYPE_RHYTHM_EVENT_ENUM.SVT,
    type: 'rhythm',
    subtype: 'other',
  },
  // {
  //   label: '1st Deg HB', value: TYPE_RHYTHM_EVENT_ENUM.AVB1, type: 'rhythm', subtype: 'other',
  // },
  {
    label: '2nd Deg HB',
    value: TYPE_RHYTHM_EVENT_ENUM.AVB2,
    type: 'rhythm',
    subtype: 'other',
  },
  {
    label: '3rd Deg HB',
    value: TYPE_RHYTHM_EVENT_ENUM.AVB3,
    type: 'rhythm',
    subtype: 'other',
  },
];

export const ID_HR_SUMMARY_TAB = 'hr-summary';
export const ID_BOOKMARK_TAB = 'ecg-bookmark';

// STRIP BEAT THUMBNAIL
export const elementToCalculateStripBeatThumbnailInfo = {
  leftColumnWidth: 180,
  paddingBothSide: 16 * 2,
  scrollbarWidth: 15,
  stripBeatGap: 8,
  paddingTopBottom: 10 * 2,
  rightColumnWidth: 245,
};
export const STRIP_BEAT_THUMBNAIL_INFO = {
  stripPerRow: 1,
  stripRow: 1,
  stripDisplayLimit: 1,
  prevStripPerRow: 1,
  prevStripRow: 1,
  prevStripDisplayLimit: 1,
};
/**
 * Sets how many beat strip thumbnails the grid shows per page. Normalises the row and column counts to positive integers, copies the current values into the prev fields so a layout change can be diffed, and recomputes the display limit as their product.
 *
 * @param stripPerRow - Thumbnails per row, coerced to a positive integer and defaulting to 1.
 * @param stripRow - Rows of thumbnails, coerced to a positive integer and defaulting to 1.
 * @returns Nothing.
 */
export const setStripBeatThumbnailInfo = ({ stripPerRow = 1, stripRow = 1 }) => {
  const newStripPerRow = Math.abs(stripPerRow || 1);
  const newStripRow = Math.abs(stripRow || 1);
  STRIP_BEAT_THUMBNAIL_INFO.prevStripPerRow = STRIP_BEAT_THUMBNAIL_INFO.stripPerRow;
  STRIP_BEAT_THUMBNAIL_INFO.prevStripRow = STRIP_BEAT_THUMBNAIL_INFO.stripRow;
  STRIP_BEAT_THUMBNAIL_INFO.prevStripDisplayLimit = STRIP_BEAT_THUMBNAIL_INFO.stripDisplayLimit;
  STRIP_BEAT_THUMBNAIL_INFO.stripPerRow = newStripPerRow;
  STRIP_BEAT_THUMBNAIL_INFO.stripRow = newStripRow;
  STRIP_BEAT_THUMBNAIL_INFO.stripDisplayLimit = newStripPerRow * newStripRow;
};

export const STRIP_TEMPLATE_BEAT_THUMBNAIL_INFO = {
  stripPerRow: 1,
  stripRow: 1,
  stripDisplayLimit: 1,
  prevStripPerRow: 1,
  prevStripRow: 1,
  prevStripDisplayLimit: 1,
};
// STRIP EVENT THUMBNAIL
export const elementToCalculateStripEventThumbnailInfo = {
  leftColumnWidth: 202,
  paddingBothSide: 16 * 2,
  scrollbarWidth: 15,
  stripBeatGap: 10,
  paddingTopBottom: 10 * 2,
};

export const elementToCalculateStripTemplateInfo = {
  leftColumnWidth: 247,
  paddingBothSide: 16 * 2,
  scrollbarWidth: 15,
  stripBeatGap: 10,
  paddingTopBottom: 10 * 2,
};

export const elementToCalculateStripManagementThumbnailInfo = {
  leftColumnWidth: 192,
  paddingBothSide: 16 * 2,
  scrollbarWidth: 15,
  stripBeatGap: 10,
  paddingTopBottom: 10 * 2,
};
export const STRIP_EVENT_THUMBNAIL_INFO = {
  stripPerRow: 1,
  stripRow: 1,
  stripDisplayLimit: 1,
  prevStripPerRow: 1,
  prevStripRow: 1,
  prevStripDisplayLimit: 1,
};
export const STRIP_MANAGEMENT_THUMBNAIL_INFO = {
  stripPerRow: 1,
  stripRow: 1,
  stripDisplayLimit: 1,
  prevStripPerRow: 1,
  prevStripRow: 1,
  prevStripDisplayLimit: 1,
};
export const STRIP_DEVICE_THUMBNAIL_INFO = {
  stripPerRow: 1,
  stripRow: 1,
  stripDisplayLimit: 1,
  prevStripPerRow: 1,
  prevStripRow: 1,
  prevStripDisplayLimit: 1,
};
/**
 * Sets how many ECG event strip thumbnails the grid shows per page. Normalises the row and column counts to positive integers, copies the current values into the prev fields so a layout change can be diffed, and recomputes the display limit as their product.
 *
 * @param stripPerRow - Thumbnails per row, coerced to a positive integer and defaulting to 1.
 * @param stripRow - Rows of thumbnails, coerced to a positive integer and defaulting to 1.
 * @returns Nothing.
 */
export const setStripEventThumbnailInfo = ({ stripPerRow = 1, stripRow = 1 }) => {
  const newStripPerRow = Math.abs(stripPerRow || 1);
  const newStripRow = Math.abs(stripRow || 1);
  STRIP_EVENT_THUMBNAIL_INFO.prevStripPerRow = STRIP_EVENT_THUMBNAIL_INFO.stripPerRow;
  STRIP_EVENT_THUMBNAIL_INFO.prevStripRow = STRIP_EVENT_THUMBNAIL_INFO.stripRow;
  STRIP_EVENT_THUMBNAIL_INFO.prevStripDisplayLimit = STRIP_EVENT_THUMBNAIL_INFO.stripDisplayLimit;
  STRIP_EVENT_THUMBNAIL_INFO.stripPerRow = newStripPerRow;
  STRIP_EVENT_THUMBNAIL_INFO.stripRow = newStripRow;
  STRIP_EVENT_THUMBNAIL_INFO.stripDisplayLimit = newStripPerRow * newStripRow;
};

/**
 * Sets how many strips management thumbnails the grid shows per page. Normalises the row and column counts to positive integers, copies the current values into the prev fields so a layout change can be diffed, and recomputes the display limit as their product.
 *
 * @param stripPerRow - Thumbnails per row, coerced to a positive integer and defaulting to 1.
 * @param stripRow - Rows of thumbnails, coerced to a positive integer and defaulting to 1.
 * @returns Nothing.
 */
export const setStripManagementThumbnailInfo = ({ stripPerRow = 1, stripRow = 1 }) => {
  const newStripPerRow = Math.abs(stripPerRow || 1);
  const newStripRow = Math.abs(stripRow || 1);
  STRIP_MANAGEMENT_THUMBNAIL_INFO.prevStripPerRow = STRIP_MANAGEMENT_THUMBNAIL_INFO.stripPerRow;
  STRIP_MANAGEMENT_THUMBNAIL_INFO.prevStripRow = STRIP_MANAGEMENT_THUMBNAIL_INFO.stripRow;
  STRIP_MANAGEMENT_THUMBNAIL_INFO.prevStripDisplayLimit =
    STRIP_MANAGEMENT_THUMBNAIL_INFO.stripDisplayLimit;
  STRIP_MANAGEMENT_THUMBNAIL_INFO.stripPerRow = newStripPerRow;
  STRIP_MANAGEMENT_THUMBNAIL_INFO.stripRow = newStripRow;
  STRIP_MANAGEMENT_THUMBNAIL_INFO.stripDisplayLimit = newStripPerRow * newStripRow;
};

/**
 * Sets how many device event strip thumbnails the grid shows per page. Normalises the row and column counts to positive integers, copies the current values into the prev fields so a layout change can be diffed, and recomputes the display limit as their product.
 *
 * @param stripPerRow - Thumbnails per row, coerced to a positive integer and defaulting to 1.
 * @param stripRow - Rows of thumbnails, coerced to a positive integer and defaulting to 1.
 * @returns Nothing.
 */
export const setStripDeviceThumbnailInfo = ({ stripPerRow = 1, stripRow = 1 }) => {
  const newStripPerRow = Math.abs(stripPerRow || 1);
  const newStripRow = Math.abs(stripRow || 1);
  STRIP_DEVICE_THUMBNAIL_INFO.prevStripPerRow = STRIP_DEVICE_THUMBNAIL_INFO.stripPerRow;
  STRIP_DEVICE_THUMBNAIL_INFO.prevStripRow = STRIP_DEVICE_THUMBNAIL_INFO.stripRow;
  STRIP_DEVICE_THUMBNAIL_INFO.prevStripDisplayLimit = STRIP_DEVICE_THUMBNAIL_INFO.stripDisplayLimit;
  STRIP_DEVICE_THUMBNAIL_INFO.stripPerRow = newStripPerRow;
  STRIP_DEVICE_THUMBNAIL_INFO.stripRow = newStripRow;
  STRIP_DEVICE_THUMBNAIL_INFO.stripDisplayLimit = newStripPerRow * newStripRow;
};
// STRIP ARTIFACT THUMBNAIL
export const elementToCalculateStripArtifactThumbnailInfo = {
  leftColumnWidth: 180 + 127,
  paddingBothSide: 16 * 2,
  scrollbarWidth: 15,
  stripBeatGap: 10,
  paddingTopBottom: 10 * 2,
};
export const STRIP_ARTIFACT_THUMBNAIL_INFO = {
  stripPerRow: 1,
  stripRow: 1,
  stripDisplayLimit: 1,
  prevStripPerRow: 1,
  prevStripRow: 1,
  prevStripDisplayLimit: 1,
};
/**
 * Sets how many artifact strip thumbnails the grid shows per page. Normalises the row and column counts to positive integers, copies the current values into the prev fields so a layout change can be diffed, and recomputes the display limit as their product.
 *
 * @param stripPerRow - Thumbnails per row, coerced to a positive integer and defaulting to 1.
 * @param stripRow - Rows of thumbnails, coerced to a positive integer and defaulting to 1.
 * @returns Nothing.
 */
export const setStripArtifactThumbnailInfo = ({ stripPerRow = 1, stripRow = 1 }) => {
  const newStripPerRow = Math.abs(stripPerRow || 1);
  const newStripRow = Math.abs(stripRow || 1);
  STRIP_ARTIFACT_THUMBNAIL_INFO.prevStripPerRow = STRIP_ARTIFACT_THUMBNAIL_INFO.stripPerRow;
  STRIP_ARTIFACT_THUMBNAIL_INFO.prevStripRow = STRIP_ARTIFACT_THUMBNAIL_INFO.stripRow;
  STRIP_ARTIFACT_THUMBNAIL_INFO.prevStripDisplayLimit =
    STRIP_ARTIFACT_THUMBNAIL_INFO.stripDisplayLimit;
  STRIP_ARTIFACT_THUMBNAIL_INFO.stripPerRow = newStripPerRow;
  STRIP_ARTIFACT_THUMBNAIL_INFO.stripRow = newStripRow;
  STRIP_ARTIFACT_THUMBNAIL_INFO.stripDisplayLimit = newStripPerRow * newStripRow;
};
// STRIP AFIB THUMBNAIL
export const elementToCalculateStripAfibThumbnailInfo = {
  leftColumnWidth: 180,
  paddingBothSide: 16 * 2,
  scrollbarWidth: 15,
  stripBeatGap: 10,
  paddingTopBottom: 10 * 2,
};
export const STRIP_AFIB_THUMBNAIL_INFO = {
  stripPerRow: 1,
  stripRow: 1,
  stripDisplayLimit: 1,
  prevStripPerRow: 1,
  prevStripRow: 1,
  prevStripDisplayLimit: 1,
};
/**
 * Sets how many AFib strip thumbnails the grid shows per page. Normalises the row and column counts to positive integers, copies the current values into the prev fields so a layout change can be diffed, and recomputes the display limit as their product.
 *
 * @param stripPerRow - Thumbnails per row, coerced to a positive integer and defaulting to 1.
 * @param stripRow - Rows of thumbnails, coerced to a positive integer and defaulting to 1.
 * @returns Nothing.
 */
export const setStripAfibThumbnailInfo = ({ stripPerRow = 1, stripRow = 1 }) => {
  const newStripPerRow = Math.abs(stripPerRow || 1);
  const newStripRow = Math.abs(stripRow || 1);
  STRIP_AFIB_THUMBNAIL_INFO.prevStripPerRow = STRIP_AFIB_THUMBNAIL_INFO.stripPerRow;
  STRIP_AFIB_THUMBNAIL_INFO.prevStripRow = STRIP_AFIB_THUMBNAIL_INFO.stripRow;
  STRIP_AFIB_THUMBNAIL_INFO.prevStripDisplayLimit = STRIP_AFIB_THUMBNAIL_INFO.stripDisplayLimit;
  STRIP_AFIB_THUMBNAIL_INFO.stripPerRow = newStripPerRow;
  STRIP_AFIB_THUMBNAIL_INFO.stripRow = newStripRow;
  STRIP_AFIB_THUMBNAIL_INFO.stripDisplayLimit = newStripPerRow * newStripRow;
};
//
export const THUMBNAIL_SKELETON_DISPLAY_LIMIT = 20;

export const KEY_CANCEL = {
  DOWLOAD_ECG: 'DOWLOAD_ECG',
  API_HOLTER_AI: 'API_HOLTER_AI',
  API_MODAL: 'API_MODAL',
};

// Tên bucket Recoil theo NGỮ NGHĨA (không theo số tab) — giá trị chuỗi là key bucket/IndexedDB, KHÔNG đổi.
export const KEY_RECOIL = {
  BEAT_HR: 'BEAT_HR',
  RHYTHM_EVENT: 'RHYTHM_EVENT',
  STRIP_MANAGEMENT: 'STRIP_MANAGEMENT',
  DEVICE_MANAGEMENT: 'DEVICE_MANAGEMENT',
  HR_SUMMARY: 'HR_SUMMARY',
};

export const IS_NOT_EDIT_REPORT_MESSAGE = 'Only the first can do it';
export const CANT_GEN_DISMISSED_REPORT =
  'The report is being dismissed, you can not generate the report now.';
export const CANT_GEN_SENT_REPORT = 'Cannot generate a report that has already been sent.';
export const CANT_UPLOAD_SENT_REPORT = 'Cannot upload a report that has already been sent.';

export const CALL_CENTER_API = 'CALL_CENTER_API';

export const AI_COMMAND = {
  BEAT: 'update-beats',
  EVENT: 'update-events',
  RR: 'reviewRrCells',
  DAILY_SUMMARY: 'updateHolterHrDailySummary',
  HEATMAP: 'rrHeatMapUpdated',
  MINUTLY_SUMMARY: 'minutelyHrUpdated',
  SAVING_STATUS: 'savingStatus',
};

export const AI_PHASE = {
  HOURLY_SUMMARY: 'HourlySummary',
  PVC_MORPHOLOGY: 'PVCUpdated',
  SVE_MORPHOLOGY: 'SVEUpdated',
  EVENTS_UPDATED: 'EventsUpdated',
  AFIB_ARTIFACT_SUMMARY: 'AFibArtifactSummary',
  MINUTELY_HR: 'MinutelyHr',
  HR_SUMMARY: 'HrSummary',
};

export const CHART_COLOR = {
  STEEL_GRAY: '#828C99', // Artifact
  STEEL_GRAY_LIGHT: '#828C9966', // 66 = 40% opacity
  STEEL_GRAY_DARK: '#828C99CC', // CC = 80% opacity
  AMBER_YELLOW: '#FFAB00', // Afib
  AMBER_YELLOW_LIGHT: '#FFAB0066',
  AMBER_YELLOW_DARK: '#FFAB00CC',
  CRIMSON_RED: '#F23D42', // Other
  CRIMSON_RED_LIGHT: '#F23D4266',
  CRIMSON_RED_DARK: '#F23D42CC',
  TURQUOISE_BLUE: '#00A3AD',
  CERULEAN_BLUE: '#0954BA',
  WHITE: '#FFFFFF',
};

export const SPEED_VALUES = [2.5, 10, 25, 50, 75, 100, 200, 500];

export const GAIN_VALUES = [1, 2, 5, 7.5, 10, 20, 50, 100, 200];

export const HP_VALUES = [0, 0.05, 0.5, 1, 2];

export const LP_VALUES = [0, 15, 30, 40, 50, 60, 100];

export const REVIEWED_BEAT_FILTER = ['Hidden', 'Visible'];

export const SORT_BEATS_OPTIONS = ['Morphology', 'Timestamp'];

export const VIEW_SOURCE_MODE_VALUE = {
  ALL: 'ALL',
  SELECTED: 'Selected',
};

export const TEMPLATE_SOURCE_OPTIONS = [
  { label: 'All beats', value: VIEW_SOURCE_MODE_VALUE.ALL, desc: 'Show morphology of all beats.' },
  {
    label: 'Selected beats',
    value: VIEW_SOURCE_MODE_VALUE.SELECTED,
    desc: 'Show morphology of selected beats from R-R heatmap.',
  },
];

export const EVENT_COUNT_CONVERT = {
  AFIB: 'afib',
  TACHY: 'tachy',
  BRADY: 'brady',
  PAUSE: 'pause',
  MAX_HR: 'maxHr',
  MIN_HR: 'minHr',
  VT: 'vt',
  SVT: 'svt',
  // AVB1: 'avb1',
  AVB2: 'avb2',
  AVB3: 'avb3',
  VE_RUN: 'veRun',
  VE_COUPLET: 'veCouplet',
  VE_BIGEMINY: 'veBigeminy',
  VE_TRIGEMINAL: 'veTrigeminal',
  VE_QUADRIGEMINY: 'veQuadrigeminy',
  SVE_RUN: 'sveRun',
  SVE_COUPLET: 'sveCouplet',
  SVE_BIGEMINY: 'sveBigeminy',
  SVE_TRIGEMINAL: 'sveTrigeminal',
  SVE_QUADRIGEMINY: 'sveQuadrigeminy',
};

//* Những event luôn đc get về để hiển thị hoặc check add/edit => phải cache
export const typesPersistEvent = [
  TYPE_RHYTHM_EVENT_ENUM.ARTIFACT,
  TYPE_RHYTHM_EVENT_ENUM.AFIB,
  TYPE_RHYTHM_EVENT_ENUM.TACHY,
  TYPE_RHYTHM_EVENT_ENUM.BRADY,
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
  // TYPE_RHYTHM_EVENT_ENUM.AVB1,
  TYPE_RHYTHM_EVENT_ENUM.AVB2,
  TYPE_RHYTHM_EVENT_ENUM.AVB3,
];

export const typesPersistEventV2 = [TYPE_RHYTHM_EVENT_ENUM.ARTIFACT, TYPE_RHYTHM_EVENT_ENUM.AFIB];

export const typesPersistEventForAfibTab = [
  TYPE_RHYTHM_EVENT_ENUM.ARTIFACT,
  TYPE_RHYTHM_EVENT_ENUM.AFIB,
  TYPE_RHYTHM_EVENT_ENUM.TACHY,
  TYPE_RHYTHM_EVENT_ENUM.BRADY,
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
  TYPE_RHYTHM_EVENT_ENUM.AVB2,
  TYPE_RHYTHM_EVENT_ENUM.AVB3,
  TYPE_BEAT_EVENT_ENUM.VE_COUPLET,
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.VE_BIGEMINY,
  TYPE_BEAT_EVENT_ENUM.VE_TRIGEMINAL,
  TYPE_BEAT_EVENT_ENUM.VE_QUADRIGEMINY,
];

export const typesVeEvent = [
  TYPE_BEAT_EVENT_ENUM.VE_COUPLET,
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.VE_BIGEMINY,
  TYPE_BEAT_EVENT_ENUM.VE_TRIGEMINAL,
  TYPE_BEAT_EVENT_ENUM.VE_QUADRIGEMINY,
];

export const eventListShowForAfibTab = [
  TYPE_RHYTHM_EVENT_ENUM.ARTIFACT,
  TYPE_RHYTHM_EVENT_ENUM.AFIB,
  TYPE_RHYTHM_EVENT_ENUM.PAUSE,
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_BEAT_EVENT_ENUM.VE_COUPLET,
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.VE_BIGEMINY,
  TYPE_BEAT_EVENT_ENUM.VE_TRIGEMINAL,
  TYPE_BEAT_EVENT_ENUM.VE_QUADRIGEMINY,
];

export const minumum3BeatsType = [
  TYPE_RHYTHM_EVENT_ENUM.VT,
  TYPE_RHYTHM_EVENT_ENUM.SVT,
  TYPE_BEAT_EVENT_ENUM.VE_RUN,
  TYPE_BEAT_EVENT_ENUM.SVE_RUN,
];

// Định danh cố định của tab (keyNumber, giữ nguyên số cũ: HR_SUMMARY="6", khuyết 5 legacy).
// keyNumber là ID opaque — thứ tự hiển thị do thứ tự phần tử MENU_CONSTANTS; backend/pingAiApi
// và bucket IndexedDB đều key theo CHUỖI. KHÔNG đổi giá trị nên KHÔNG cần migration.
export const TAB_KEY = {
  BEATS: '1',
  ECG_EVENTS: '2',
  HR_SUMMARY: '6',
  STRIPS_MANAGEMENT: '3',
  PDF_REPORT: '4',
} as const;

// Ánh xạ TAB_KEY (keyNumber) → bucket Recoil, tường minh thay cho ghép chuỗi
// `KEY_RECOIL[`TAB_${activeTab}`]`. Giá trị chuỗi bucket KHÔNG đổi → key IndexedDB không đổi.
export const TAB_RECOIL_BUCKET = {
  [TAB_KEY.BEATS]: KEY_RECOIL.BEAT_HR,
  [TAB_KEY.ECG_EVENTS]: KEY_RECOIL.RHYTHM_EVENT,
  [TAB_KEY.HR_SUMMARY]: KEY_RECOIL.HR_SUMMARY,
  [TAB_KEY.STRIPS_MANAGEMENT]: KEY_RECOIL.STRIP_MANAGEMENT,
  // Quirk giữ từ main: tab PDF Report ('4') dùng chung bucket DEVICE_MANAGEMENT (trước là KEY_RECOIL.DEVICE_MANAGEMENT).
  [TAB_KEY.PDF_REPORT]: KEY_RECOIL.DEVICE_MANAGEMENT,
} as const;

// Thứ tự phần tử = thứ tự hiển thị tab. CHỦ ĐÍCH đổi so với main: HR Summary xếp SAU ECG Events.
export const MENU_CONSTANTS = [
  { key: 'BEATS', title: 'Beats', keyNumber: TAB_KEY.BEATS },
  { key: 'ECG_EVENTS', title: 'ECG Events', keyNumber: TAB_KEY.ECG_EVENTS },
  { key: 'HR_SUMMARY', title: 'HR Summary', keyNumber: TAB_KEY.HR_SUMMARY },
  { key: 'STRIPS_MANAGEMENT', title: 'Strips Management', keyNumber: TAB_KEY.STRIPS_MANAGEMENT },
  { key: 'PDF_REPORT', title: 'PDF Report', keyNumber: TAB_KEY.PDF_REPORT },
];

export const AIRP_TAB = {
  BEATS: 'Beats',
  PVC: 'PVC',
  HR_SUMMARY: 'HrSummary',
  ECG_EVENTS: 'ECGEvents',
  STRIPS_MANAGEMENT: 'StripsManagement',
  SVE: 'SVE',
};

export const SUGGEST_COMMENT = [
  'Baseline',
  'Sinus Rhythm',
  'Sinus Bradycardia',
  'Sinus Tachycardia',
  'Atrial Fibrillation/Flutter',
  'Supraventricular Tachycardia',
  'Ventricular Tachycardia',
];
